export default class RestoreQuicksearch {
    constructor(element) {
        const backToSearchEntry = JSON.parse(sessionStorage.getItem('hpBackToSearch'));

        this.$element = $(element);
        this.query = backToSearchEntry !== null ? backToSearchEntry.query : {};
    }

    init() {
        const countData = this.query;

        if (typeof(this.query['attr_m_channel_i']) !== 'undefined') {
            this.query['attr_m_channel_i'].forEach((v) => {
                $(`#quicksearch-form-can-be-restored [name="attr_m_channel_i"][value="${v}"]`).prop('checked', true);
            });
        }

        if (typeof(this.query['maker']) !== 'undefined') {
            const maker = this.query['maker'][0];
            $('#quicksearch-form-can-be-restored [name="maker"]').val(maker);
            $('#quicksearch-form-can-be-restored [name="attr_m_trim"]').val(maker);
            countData["attr_m_trim"] = [maker];
            delete countData.maker;
        }

        if (typeof(this.query['model']) !== 'undefined') {
            const model = this.query['model'][0];
            this.$element.on('optionsTreeUpdate:finish', () => {
                $('#quicksearch-form-can-be-restored [name="model"]').val(model);
            });
            // if present, this will overwrite the previous one
            $('#quicksearch-form-can-be-restored [name="attr_m_trim"]').val(model);
            countData["attr_m_trim"] = [model];
            delete countData.model;
        }

        if (typeof(this.query['attr_price_max']) !== 'undefined') {
            $('#quicksearch-form-can-be-restored [name="attr_price_max"]').val(this.query['attr_price_max'][0]);
        }

        if (typeof(this.query['attr_m_km_max']) !== 'undefined') {
            $('#quicksearch-form-can-be-restored [name="attr_m_km_max"]').val(this.query['attr_m_km_max'][0]);
        }

        if (typeof(this.query['attr_m_fuel']) !== 'undefined') {
            $('#quicksearch-form-can-be-restored [name="attr_m_fuel"]').val(this.query['attr_m_fuel'][0]);
        }

        if (typeof(this.query['attr_m_year_min']) !== 'undefined') {
            $('#quicksearch-form-can-be-restored [name="attr_m_year_min"]').val(this.query['attr_m_year_min'][0]);
        }

        if (typeof(this.query['location_name']) !== 'undefined') {
            $('#zipcode').val(this.query['location_name'][0]);
            $('#quicksearch-form-can-be-restored [name="area_id"]').val(this.query['area_id'][0]);
            delete countData.location_name;
        } else if (typeof(this.query['zipcode']) !== 'undefined') {
            const zipcode = this.query['zipcode'][0].split(',')[0];
            $('#zipcode').val(zipcode);
            $('#quicksearch-form-can-be-restored [name="area_id"]').val(zipcode);
        }

        if (typeof(this.query['radius']) !== 'undefined') {
            const $radiusEl = $('#quicksearch-form-can-be-restored [name="radius"]');
            $radiusEl.prop('disabled', false);
            $radiusEl.val(this.query['radius'][0]);
        }

        countData.attr_category = ["cars"];

        const ajaxOptions = {
            method: 'POST',
            data: JSON.stringify({params: this.query}),
            processData: false,
            headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'cache-control': 'no-cache'}
        };

        $.ajax('/rest/count', ajaxOptions).done(function (data) {
            $('#quick-search-submit-button').text(data.formattedCount + ' Risultati');
        });
    }
}
